module.exports = __webpack_public_path__ + "static/media/Samosas-small.1163442b.jpg";